import { fetchApi } from "@/lib/utils";
import { Button } from "../ui/button"
import { useSession } from "next-auth/react";
import { toast } from "../ui/use-toast";
import { useEffect, useState } from "react";
import { set } from "date-fns";

interface ThematicProps {
    name: string
    resourceIdObjMeta: {drupal_internal__target_id: number}
  }
const ThematicBannerComponent = ({ thematic }: {thematic: ThematicProps}) => {
    const { data, update, status } = useSession()
    const [subscribed, setSubscribed] = useState(true)

    useEffect(() => {
        if (isAlreadySubscribed()) {
            setSubscribed(true)
        } else {
            setSubscribed(false)
        }
    }, [data])

    const isAlreadySubscribed = () => {
        if (data?.user?.thematics && thematic.resourceIdObjMeta.drupal_internal__target_id ) {
            const thematicId: number = thematic.resourceIdObjMeta.drupal_internal__target_id
            return data.user.thematics.includes(thematicId)
        }
    }

    async function onSubmit() {
        if (isAlreadySubscribed()) {
            toast({ title: "Vous êtes déjà abonné à cette thématique" });
            return
        }
        const thematicId: number = thematic.resourceIdObjMeta.drupal_internal__target_id
        let thematicList: number[] = [...data?.user?.thematics || [], thematicId]

        try {
          const response = await fetchApi(`/api/user-subscriptions`, {
            method: "POST",
            headers: {
              'Content-Type': 'application/json',
              "Authorization": `Bearer ${data?.accessToken}`
            },
            body: JSON.stringify({thematics: thematicList})
          });
          if (!response.ok && response.success === false) {
            throw new Error("Network response was not ok")
          }
          await update({thematics: thematicList})
          setSubscribed(true)
          toast({ title: "Abonnements enregistrés" })
        } catch (e) {
          toast({
            description: 'Erreur lors de l\'envoi du formulaire'
          })
        }
      }
    return (
        <>
          {
            status === 'authenticated' ?
              <>
                <div>
                  {!subscribed &&
                    <div className="bg-[#e3f0fa] text-center p-6 mt-10 mb-10">
                      <div>
                        <p className="text-[#005EB3] font-rubik text-2xl font-normal leading-tight">{`Suivre la thématique "${thematic.name}"`}</p>
                      </div>
                      <div className="flex justify-center pt-3 pb-6">
                        <div className="w-full md:w-1/2 lg:w-1/3 text-[#656D7F]">
                          <div className="flex justify-center">
                            <span className="max-w-md text-base">Suivre la thématique {thematic.name} pour personnaliser votre expérience connecté</span>
                          </div>
                        </div>
                      </div>
                      <Button className="font-rubik text-xl font-normal leading-tight" onClick={onSubmit}>
                        S&apos;abonner à la thématique
                      </Button>
                    </div>
                  }
                </div>
              </>
              :
              <></>
          }
        </>
    )
}

export default ThematicBannerComponent
